import React from "react";
import Statistics from "./Statistics/index";
import RevenueEarned from "./RevenueEarned";
import CurrentInventory from "./CurrentInventory/index";
import ProductCategoryStats from "./ProductCategoryStats/index";
import InventoryFlow from "./InventroyFlow";

const Dashboard = () => {
  return (
    <>
      <Statistics />
      <div className="row">
        <RevenueEarned />
        <CurrentInventory />
        <ProductCategoryStats />
        <InventoryFlow />
      </div>
    </>
  );
};

export default Dashboard;
